import { render, staticRenderFns } from "./counter-records-table-column-image.vue?vue&type=template&id=1ec3a556&"
import script from "./counter-records-table-column-image.vue?vue&type=script&lang=ts&"
export * from "./counter-records-table-column-image.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../tmp/ffsecurity-ui/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports